import { observer } from "mobx-react"
import React from "react"

export const FilterEventTypeBar = observer(({ page, items, filterEventType = page.filterEventType }) => {
	if (!filterEventType || !items || items.length === 0) return null

	// MTVW-624: only show when there is content
	const visibility = []
	//console.debug("filterType tabFilter live", page.applyTabFilter(items, page.FILTER_EVENT_LIVE_REPLAY) != null)
	visibility[page.FILTER_EVENT_LIVE_REPLAY] = page.applyTabFilter(items, page.FILTER_EVENT_LIVE_REPLAY) != null
	// MTVW-1016: FILTER_EVENT_RECORDINGS
	visibility[page.FILTER_EVENT_RECORDINGS] = page.applyTabFilter(items, page.FILTER_EVENT_RECORDINGS) != null
	visibility[page.FILTER_EVENT_UPCOMING] = page.applyTabFilter(items, page.FILTER_EVENT_UPCOMING) != null
	visibility[page.FILTER_EVENT_ALL] = page.applyTabFilter(items, page.FILTER_EVENT_ALL) != null
	//console.debug("filterType_1", visibility)
	
	const _outdated_checkVisibility = () => {
		if (!visibility[page.FILTER_EVENT_LIVE_REPLAY] && !visibility[page.FILTER_EVENT_UPCOMING]) {
			//console.debug("case 1", page.filterEventType)
			//page.setFilterEventType(page.FILTER_EVENT_ALL)
			if (!visibility[page.FILTER_EVENT_RECORDINGS]) page.setFilterEventType(page.FILTER_EVENT_ALL)
			else { 
				// prevent display of "Alle" which would not be selectable
				page.setFilterEventType(page.FILTER_EVENT_RECORDINGS)
				visibility[page.FILTER_EVENT_ALL] = false
			}
			visibility[page.FILTER_EVENT_LIVE_REPLAY] = false
			visibility[page.FILTER_EVENT_UPCOMING] = false
		}
		else if (!visibility[page.FILTER_EVENT_LIVE_REPLAY]) {
			//console.debug("case 2", page.filterEventType)
			//page.setFilterEventType(page.FILTER_EVENT_UPCOMING)
			/* MTVW-1016 item 1: replaced with code below
			if (page.filterEventType === page.FILTER_EVENT_LIVE_REPLAY) {
				if (visibility[page.FILTER_EVENT_RECORDINGS]) page.setFilterEventType(page.FILTER_EVENT_RECORDINGS)
				else if (visibility[page.FILTER_EVENT_UPCOMING]) page.setFilterEventType(page.FILTER_EVENT_UPCOMING)
			}
			*/
			if (visibility[page.FILTER_EVENT_RECORDINGS]) page.setFilterEventType(page.FILTER_EVENT_RECORDINGS)
			else if (visibility[page.FILTER_EVENT_UPCOMING]) page.setFilterEventType(page.FILTER_EVENT_UPCOMING)
			visibility[page.FILTER_EVENT_ALL] = false
		}
		else if (!visibility[page.FILTER_EVENT_UPCOMING]) {
			//console.debug("case 3", page.filterEventType)
			//page.setFilterEventType(page.FILTER_EVENT_LIVE_REPLAY)
			/* MTVW-1016 item 1: replaced with code below
			if (page.filterEventType === page.FILTER_EVENT_LIVE_REPLAY ) page.setFilterEventType(page.FILTER_EVENT_LIVE_REPLAY)
			else if (page.filterEventType === page.FILTER_EVENT_RECORDINGS ) page.setFilterEventType(page.FILTER_EVENT_RECORDINGS)
			*/
			if (visibility[page.FILTER_EVENT_LIVE_REPLAY]) page.setFilterEventType(page.FILTER_EVENT_LIVE_REPLAY)
			else if (visibility[page.FILTER_EVENT_RECORDINGS]) page.setFilterEventType(page.FILTER_EVENT_RECORDINGS)
			visibility[page.FILTER_EVENT_ALL] = false
		}
	}
	
	const checkVisibility = () => {
		const checkItems = [page.FILTER_EVENT_LIVE_REPLAY, page.FILTER_EVENT_RECORDINGS, page.FILTER_EVENT_UPCOMING, page.FILTER_EVENT_ALL]
		const visible = checkItems.filter(i => visibility[i] && i !== page.FILTER_EVENT_ALL)
		visibility[page.FILTER_EVENT_ALL] = visible.length > 1
		const selectedFilterType = checkItems.filter(i => visibility[i] && i === page.filterEventType)
		if (selectedFilterType.length === 0) page.setFilterEventType(visible[0])
		//console.debug("visible=", visible, selectedFilterType)
	}

	checkVisibility()
	//console.debug("filterType_2", visibility)

	return (
		<div className="searchFilterTypeEvents">
			<div style={{ display: visibility[page.FILTER_EVENT_LIVE_REPLAY] ? 'flex' : 'none' }} className={`${filterEventType === page.FILTER_EVENT_LIVE_REPLAY ? "searchFilterTypeEventsItem searchFilterTypeEventsItemSelected" : "searchFilterTypeEventsItem"}`}
				onClick={() => {
					page.setFilterEventType(page.FILTER_EVENT_LIVE_REPLAY, true)
				}}
				data_test="filter_type_live_and_replay_events"
			>{page.FILTER_EVENT_LIVE_REPLAY}</div>
			{/* MTVW-1016: FILTER_EVENT_RECORDINGS */}
			<div style={{ display: visibility[page.FILTER_EVENT_RECORDINGS] ? 'flex' : 'none' }} className={`${filterEventType === page.FILTER_EVENT_RECORDINGS ? "searchFilterTypeEventsItem searchFilterTypeEventsItemSelected" : "searchFilterTypeEventsItem"}`}
				onClick={() => {
					page.setFilterEventType(page.FILTER_EVENT_RECORDINGS, true)
				}}
				data_test="filter_type_recordings"
			>{page.FILTER_EVENT_RECORDINGS}</div>
			<div style={{ display: visibility[page.FILTER_EVENT_UPCOMING] ? 'flex' : 'none' }} className={`${filterEventType === page.FILTER_EVENT_UPCOMING ? "searchFilterTypeEventsItem searchFilterTypeEventsItemSelected" : "searchFilterTypeEventsItem"}`}
				onClick={() => {
					page.setFilterEventType(page.FILTER_EVENT_UPCOMING, true)
				}}
				data_test="filter_type_upcoming_events"
			>{page.FILTER_EVENT_UPCOMING}</div>
			{/* MTVW-620: FILTER_EVENT_ALL at the end */}
			<div style={{ display: visibility[page.FILTER_EVENT_ALL] ? 'flex' : 'none' }} className={`${filterEventType === page.FILTER_EVENT_ALL ? "searchFilterTypeEventsItem searchFilterTypeEventsItemSelected" : "searchFilterTypeEventsItem"}`}
				onClick={() => {
					page.setFilterEventType(page.FILTER_EVENT_ALL, true)
				}}
				data_test="filter_type_all_events"
			> {page.FILTER_EVENT_ALL}</div>
		</div>
	)
})
